// vue babel plugin doesn't support pragma replacement
import { mdx } from '@mdx-js/vue'
let h;
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`About`}</strong></p>
    <ul>
      <li parentName="ul">{`In the top left you have controls for your microphone and to control going live`}</li>
      <li parentName="ul">{`On the right you can see which interpreters are online in this booth and send them messages`}</li>
      <li parentName="ul">{`Messages you send will only go to interpreters in this booth.`}</li>
    </ul>
    <p><strong parentName="p">{`How to use this interface`}</strong></p>
    <ol>
      <li parentName="ol">{`If you don't see your microphone(s) listed on the left, click `}<strong parentName="li">{`Refresh devices`}</strong></li>
      <li parentName="ol">{`Check the `}<strong parentName="li">{`Title`}</strong>{`, `}<strong parentName="li">{`Floor language`}</strong>{` and `}<strong parentName="li">{`Output language`}</strong>{` match the session you have been assigned to interpret for.
If they do not match, click `}<strong parentName="li">{`Back to interpretation`}</strong>{` and find the correct session`}</li>
      <li parentName="ol">{`Make sure you are already in the zoom room where the live event is happening.
You will have been emailed a zoom invite.`}</li>
      <li parentName="ol">{`When it is your turn, press "Go live" to start broadcasting`}</li>
      <li parentName="ol">{`If you need to stop you can message other interpretes in the booth to ask them to take over`}</li>
      <li parentName="ol">{`When the session is over, press `}<strong parentName="li">{`Disconnect`}</strong></li>
    </ol>
    <p><strong parentName="p">{`Taking over`}</strong></p>
    <ul>
      <li parentName="ul">{`When another interpreter is broadcasting you can see that where the `}<strong parentName="li">{`Go live`}</strong>{` button usually is`}</li>
      <li parentName="ul">{`To take over press `}<strong parentName="li">{`Takeover`}</strong></li>
      <li parentName="ul">{`This will stop their broadcast immediatly and start your broadcast`}</li>
      <li parentName="ul">{`Use the messages to help communicate this changeover`}</li>
      <li parentName="ul">{`Remember to press `}<strong parentName="li">{`Send`}</strong>{` when you want to send your message`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export default {
  name: 'Mdx',
  inject: {
    $mdxComponents: {
      default: () => () => ({})
    }
  },
  computed: {
    components() {
      return this.$mdxComponents()
    }
  },
  render(createElement) {
    h = mdx.bind({ createElement, components: this.components })
    return MDXContent({ components: this.components })
  }
}
   